import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import WmsModel from "./../components/WmsModel/WmsModel";
import WmsDropdown from "./../components/WmsDropdown/WmsDropdown";
import WmsDropdownList from "./../components/WmsDropdownList/WmsDropdownList";
import WmsInput from "./../components/WmsInput/WmsInput";
import WMSGridCheckBoxSelection from "../components/WMSGridCheckBoxSelection/WMSGridCheckBoxSelection";
import WmsCheckBox from "./../components/WmsCheckBox/WmsCheckBox";
import WmsButton from "./../components/WmsButton/WmsButton";
import * as GridConfig from "./audit-inventory-grid-configuration";

import "./audit-inventory.scss";
// import { StringWms } from "../../../assets/ts/StringWms";
import WmsDateTimePicker from "../components/WmsDateTimePicker/WmsDateTimePicker";
import * as auditInventoryServices from "./audit-inventory.services";
import * as GlobalService from "../global_services";
import { ConcurrencyManager } from "../../../assets/vendor/concurrencyManager/concurrencyManager";
import { LoadingModel } from "../../react/components/LoadingModel/LoadingModel";

import _ from "lodash";
// import { KendoWms } from "../../../assets/ts/KendoWms";
import WmsToolTip from "../components/WmsToolTip/WmsToolTip";
import WmsFormGrid from "../components/WmsFormGrid/WmsFormGrid";
import WmsRadio from "../components/WmsRadio/WmsRadio";
import {
    computeLeftGridDataAfterMoveFromJob,
    computeLeftGridDataAfterMoveToJob,
    getItemLocationPoolFromResponse,
} from "./audit-inventory-item-location-pool";
import type { LocationFilterType } from "./audit-inventory-item-location-pool";

declare var window: any;

interface Props {
    onCloseManageAuditInventoryModal: any;
    isOpenManageAuditInventoryModal: boolean;
    wmsSelector: string;
    windowId: string;
    userOptions: any;
    locationTypes: any;
    getAuditOptions: any;
    facId: number;
    facUri: string;
    selectedRowData: any;
    auditType: string;
}
const defaultAuditJobObject = {
    Name: "",
    Notes: "",
    Priority: 8,
    AuditType: "Item",
    UseTrackBys: true,
    Locations: [],
    AssignedTo: { Id: "" },
    EditUri: "",
    ItemId: "",
    BatchName: null,
};

const defaultFilterObject = {
    LocationName: "",
    LastCounted: "",
    LocationType: 0,
    ItemId: "",
    customerId: 0,
    pastndays: 60,
    hideInactive: true,
};

const ManageAuditInventoryModal: React.FC<Props> = (incomingProps: Props): any => {
    const {
        onCloseManageAuditInventoryModal = (): void => {},
        isOpenManageAuditInventoryModal = false,
        wmsSelector = "",
        windowId = "",
        auditType = "Create",
    } = incomingProps;
    const props = {
        ...incomingProps,
        onCloseManageAuditInventoryModal,
        isOpenManageAuditInventoryModal,
        wmsSelector,
        windowId,
        auditType,
    };

    const CustomerOptions = GlobalService.filteredCustomerList(GlobalService.getCustomerList(true), props.facId);
    // const optionContains = StringWms.convertSringToOption(window.translate("Options_SearchBy_StringOptions"));
    const defaultItemsColumns = GridConfig.itemsGridColumns();
    const defaultLocationsColumns = GridConfig.locationsGridColumns();
    const [schema] = useState(GridConfig.locationsGridSchema().schema);
    const [jobLocationsSchema] = useState(GridConfig.jobLocationsGridSchema().schema);
    const [assignedToOptions] = useState(props.userOptions);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [locationNoOfSelection, setLocationNoOfSelection] = useState(0);
    const [jobLocationsGridData, setJobLocationsGridData] = useState([]);
    const [auditJobObj, setAuditJobObj] = useState(defaultAuditJobObject);
    const [locationGridKeyNumber, setLocationGridKeyNumber] = useState(0);
    const [filterObj, setFilterObj] = useState(defaultFilterObject);
    const [locationType, setLocationType] = useState<LocationFilterType>("other");
    const jobLocationColumns = GridConfig.jobLocationsGridColumns(auditJobObj.AuditType);
    const [locationTypes] = useState(props.locationTypes);
    const [isSaveAuditJobLoading, setIsSaveAuditJobLoading] = useState(false);
    const [, setResponseData] = useState(null);
    const [responseLocationGridData, setResponseLocationGridData] = useState([]);
    const [locationGridData, setLocationGridData] = useState([]);
    const [showDataNote, setShowDataNote] = useState(false);
    const [itemSize] = useState([
        { text: "60 Days", value: 60 },
        { text: "90 Days", value: 90 },
        { text: "120 Days", value: 120 },
        { text: "180 Days", value: 180 },
    ]);
    const [auditTypeOptions] = useState([
        {
            name: "Item",
            value: "Item",
        },
        {
            name: "Location",
            value: "Location",
        },
    ]);
    const [jobPriorityOption] = useState([
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
        { value: 6, text: 6 },
        { value: 7, text: 7 },
        { value: 8, text: 8 },
        { value: 9, text: 9 },
        { value: 10, text: 10 },
    ]);
    let isApiCanceled = false;
    const [overlayScreenShow, setOverlayScreenShow] = useState(false);
    const [totalRequest, setTotalRequest] = useState(0);
    const [recordsCount, setRecordsCount] = useState(0);
    const isInitialLocationTypeRender = useRef(true);

    let axiosSource = null;
    const gridPageSize = 1000;
    const lastCountedDateFormat = "MMM dd,yyyy";

    useEffect(() => {
        if (props.auditType === "Edit") {
            var assignedTo = props.selectedRowData.AssignedTo?.Id !== 0 ? props.selectedRowData.AssignedTo : { Id: "" };
            setAuditJobObj({
                Name: props.selectedRowData.Name,
                Notes: props.selectedRowData.Notes,
                Priority: props.selectedRowData.Priority,
                AuditType: props.selectedRowData.AuditType,
                UseTrackBys: props.selectedRowData.UseTrackBys,
                Locations: props.selectedRowData.Locations,
                AssignedTo: assignedTo,
                EditUri: props.selectedRowData.EditUri,
                ItemId: props.selectedRowData.ItemId,
                BatchName: props?.selectedRowData?.BatchName,
            });
            setFilterObj((prevState: any) => ({
                ...prevState,
                customerId: props.selectedRowData.CustomerId,
            }));
            let tmpJobLocation = [];
            for (let i = 0; i < props.selectedRowData.Locations.length; i++) {
                // eslint-disable-next-line security/detect-object-injection
                const location = props.selectedRowData.Locations[i];
                location.IsRequired = false;
                tmpJobLocation.push(location);
            }
            setJobLocationsGridData(tmpJobLocation);
            onFilterChangeDebounceCall();
            setLocationGridKeyNumber((ps) => ps + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedRowData, props.auditType]);

    const buildLocationGridReadBody = () => {
        const body: any = {
            facilityId: props.facId,
            auditType: auditJobObj.AuditType,
            itemid: auditJobObj.ItemId,
            hideInactive: filterObj.hideInactive,
        };
        if (locationType === "suggested") {
            body.pastndays = filterObj.pastndays;
        }
        return body;
    };

    const getLocationGridData = () => {
        if (!auditJobObj.ItemId && auditJobObj.AuditType === "Item") {
            setLocationGridData([]);
            return;
        }
        const dataPayload: any = {
            ...buildLocationGridReadBody(),
            page: 1,
            pageSize: gridPageSize,
        };
        auditInventoryServices.locationGridReadData(dataPayload).then((response) => {
            setResponseData({ data: { ...response.data } });
            const modifiedData = onRequestEnd({ ...response });
            const resDataArr = modifiedData;
            let tempResponseLocationGridData = [];
            if (auditJobObj.AuditType === "Item") {
                tempResponseLocationGridData = getItemLocationPoolFromResponse(response.data.Data[0], locationType);
            } else {
                tempResponseLocationGridData = response.data.Data || [];
            }
            setResponseLocationGridData([...tempResponseLocationGridData]);
            setLocationGridData(resDataArr);
            kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), false);
        });
    };
    function selectRow(selectedIdObj) {
        setLocationNoOfSelection(Object.keys(selectedIdObj).length);
    }

    useEffect(() => {
        getLocationGridData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterObj.hideInactive]);

    const onChangeJobFields = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "AssignedTo") {
            value = { Id: value.Id };
        } else if (name === "UseTrackBys") {
            value = e.target.checked;
        } else if (name === "AuditType") {
            resetGridsData(true);
            setFilterObj(defaultFilterObject);
            onFilterChangeDebounceCall();
            setLocationGridKeyNumber((ps) => ps + 1);
        }
        setAuditJobObj((prevState: any) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const moveLocationToJob = () => {
        let grid = $(`#${props.wmsSelector}LocationGrid`).data("kendoGrid");
        let selectedGridItem = grid.select();
        // eslint-disable-next-line sonarjs/no-unused-collection
        let selectionArr = [];
        for (let i = 0; i < selectedGridItem.length; i++) {
            // eslint-disable-next-line security/detect-object-injection
            let itemObj = selectedGridItem[i];
            if (itemObj) {
                const selectedItem = grid.dataItem(itemObj);
                if (selectedItem && !jobLocationsGridData.some((loc) => loc["Id"] === selectedItem["Id"])) {
                    selectionArr.push(selectedItem);
                }
            }
        }
        let selectedIDs = jobLocationsGridData.map((sa) => sa.Id);
        selectionArr.forEach((sa) => selectedIDs.push(sa.Id));
        let tempArr = computeLeftGridDataAfterMoveToJob(responseLocationGridData, selectedIDs);
        let tmpSelectedLocationsItem = _.cloneDeep(jobLocationsGridData);
        // Kendo persistSelection only drops ids of rows still rendered, so clear before the rows leave the grid.
        grid.clearSelection();
        setJobLocationsGridData(_.concat(tmpSelectedLocationsItem, selectionArr));
        setLocationNoOfSelection(0);
        setLocationGridData(tempArr);
    };
    const moveJobToLocation = () => {
        let auditJobLocationGrid = $("#" + props.wmsSelector + "AuditJobLocation").data("kendoGrid");
        let selectedAuditJobLocationGrid = auditJobLocationGrid.select();
        let locationIdsArr = [];
        if (selectedAuditJobLocationGrid.length > 0) {
            for (let i = 0; i < selectedAuditJobLocationGrid.length; i++) {
                // eslint-disable-next-line security/detect-object-injection
                let itemObj = selectedAuditJobLocationGrid[i];
                if (itemObj) {
                    const selectedItem = auditJobLocationGrid.dataItem(itemObj);
                    if (selectedItem && selectedItem["IsRequired"] === false) {
                        locationIdsArr.push(selectedItem["Id"]);
                    }
                }
            }
            let selectedIDs = locationGridData.map((sa) => sa.Id);
            let tempArr = computeLeftGridDataAfterMoveFromJob(responseLocationGridData, locationIdsArr, selectedIDs);

            let clonedJobLocationsGridData = _.cloneDeep(jobLocationsGridData);
            let tmpSelectedLocationsItem = clonedJobLocationsGridData.filter((x) => !locationIdsArr.includes(x.Id));
            // Kendo persistSelection only drops ids of rows still rendered, so clear before the rows leave the grid.
            auditJobLocationGrid.clearSelection();
            setJobLocationsGridData(tmpSelectedLocationsItem);
            setLocationGridData(tempArr);
        }
    };
    const onRequestEnd = (e: any) => {
        if (!props.isOpenManageAuditInventoryModal) {
            return;
        }
        let locationData = [];
        let recentStockLocationList = [];
        let otherLocationList = [];
        if (auditJobObj.AuditType === "Item") {
            if (locationType === "suggested") {
                recentStockLocationList = e.data.Data[0]?.RecentStockLocationList || [];
                recentStockLocationList.forEach((location) => {
                    location.IsSuggested = true;
                    location.IsRequired = false;
                });
            } else if (locationType === "other") {
                otherLocationList = e.data.Data[0]?.OtherLocationList || [];
                otherLocationList.forEach((location) => {
                    location.IsSuggested = false;
                    location.IsRequired = false;
                });
            }
            locationData = [...recentStockLocationList, ...otherLocationList];
            const requiredLocations = e.data.Data[0]?.AuditLocations || [];
            requiredLocations.forEach((location) => {
                location.IsRequired = true;
                locationData.forEach((l) => {
                    if (l.Id === location.Id) {
                        l.IsRequired = true;
                    }
                });
            });
            locationData.unshift(...requiredLocations);
        } else {
            locationData = e.data.Data.map((location) => {
                location.IsRequired = false;
                return location;
            });
        }
        var gridData = loadRequiredAuditLocations(locationData);
        const locationIdsArr = _.map(gridData, "Id");
        let tempArr = locationData.filter((x) => locationIdsArr.indexOf(x.Id) === -1);
        _.forEach(tempArr, function (item) {
            item.LastCounted = kendo.toString(kendo.parseDate(item.LastCounted), lastCountedDateFormat);
        });
        setJobLocationsGridData(gridData);
        return tempArr;
    };

    const resetGridsData = (clearJobLocationDataYn) => {
        let locationGrid = $("#" + props.wmsSelector + "LocationGrid").data("kendoGrid");
        // defaultLocationFilterObject.Location = "";
        // auditInventoryServices.locationGridSearchInfoSend(defaultLocationFilterObject);
        if (locationGrid) {
            if (clearJobLocationDataYn) {
                setJobLocationsGridData([]);
                setResponseData(null);
                setResponseLocationGridData([]);
                setLocationGridData([]);
            }
            locationGrid.dataSource.data([]);
        }
    };

    const loadRequiredAuditLocations = (locationsData) => {
        if (locationsData) {
            let auditJobLocationData = [...jobLocationsGridData];
            let tmpAuditJobLocationData = _.cloneDeep(auditJobLocationData);
            let requiredLocations = [];
            if (auditJobObj.AuditType === "Item") {
                for (let locationIndex = 0; locationIndex < locationsData.length; locationIndex++) {
                    // eslint-disable-next-line security/detect-object-injection
                    let locationObj = locationsData[locationIndex];
                    tmpAuditJobLocationData.map((l) => {
                        if (l.Id === locationObj.Id) {
                            l.IsRequired = locationObj.IsRequired;
                        }
                        return l;
                    });
                    if (
                        locationObj &&
                        locationObj.IsRequired &&
                        !auditJobLocationData.some((loc) => loc["Id"] === locationObj.Id)
                    ) {
                        requiredLocations.push(locationObj);
                    }
                }
            }
            return _.concat(tmpAuditJobLocationData, requiredLocations);
        }
        return [];
    };

    const onItemFilterChange = (event) => {
        if (event.dataItem !== undefined && event.dataItem.Id !== "") {
            setAuditJobObj((prevState: any) => ({
                ...prevState,
                ItemId: event.dataItem.Id,
            }));
            resetGridsData(true);
            onFilterChangeDebounceCall();
            setLocationGridKeyNumber((ps) => ps + 1);
        }
    };
    const onFilterChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "customerId") {
            setAuditJobObj((prevState: any) => ({
                ...prevState,
                ItemId: "",
            }));
            value = parseInt(value);
        }
        setFilterObj((prevState: any) => ({
            ...prevState,
            [name]: value,
        }));

        resetGridsData(false);
        onFilterChangeDebounceCall();
        // setLocationGridKeyNumber((ps) => ps + 1);
    };
    // Cancel axios call if new filter applied
    const cancelLoadAllData = () => {
        if (axiosSource) {
            axiosSource.cancel();
            axiosSource = null;
        }
        isApiCanceled = true;
        kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), false);

        setOverlayScreenShow(false);
        setLocationGridData([]);
    };
    const loadAllData = () => {
        kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), true);
        resetGridsData(false);
        setOverlayScreenShow(true);
        isApiCanceled = false;
        setLocationGridData([]);
        const param_filterObj = buildLocationGridReadBody();
        axiosSource = axios.CancelToken.source();
        let api = axios.create({
            baseURL: "/WebUI/Inventory/EditAudits",
            headers: { "Access-Control-Allow-Origin": "*" },
            cancelToken: axiosSource.token,
        });
        const MAX_CONCURRENT_REQUESTS = 3;
        let tempTotalRequest = Math.ceil(recordsCount / gridPageSize);
        setTotalRequest(tempTotalRequest);
        var manager = ConcurrencyManager(api, MAX_CONCURRENT_REQUESTS, GlobalService);
        const URL = auditJobObj.AuditType === "Item" ? "/ItemAuditLocationsGridRead" : "/AuditLocationsGridRead";
        Promise.all(
            sequence(tempTotalRequest).map((i) =>
                api.post(URL + "?sorts=[]&filters=[]&page=" + (i + 1) + "&pageSize=" + gridPageSize, param_filterObj)
            )
        )
            .then((responses) => {
                let inventoryData = responses.map((r) => r.data);
                getAllResponseData(inventoryData);
            })
            .catch((error) => {
                console.log("Promise.all catch", error);
                cancelLoadAllData();
            })
            .then(() => {
                if (manager) {
                    manager.detach();
                }
            });
        // onFilterChangeDebounceCall();
        setLocationGridKeyNumber((ps) => ps + 1);
    };
    const getAllResponseData = (data) => {
        if (!isApiCanceled) {
            let allData = [];
            if (auditJobObj.AuditType === "Item") {
                allData[0] = {
                    RecentStockLocationList: [],
                    OtherLocationList: [],
                    AuditLocations: [],
                };

                data.forEach((obj) => {
                    obj.Data[0].AuditLocations = obj.Data[0].AuditLocations.filter(
                        (el) => !allData[0].AuditLocations.some((d) => d.Id === el.Id)
                    );
                    allData[0] = {
                        RecentStockLocationList: [
                            ...allData[0].RecentStockLocationList,
                            ...obj.Data[0].RecentStockLocationList,
                        ],
                        OtherLocationList: [...allData[0].OtherLocationList, ...obj.Data[0].OtherLocationList],
                        AuditLocations: [...allData[0].AuditLocations, ...obj.Data[0].AuditLocations],
                    };
                });
            } else {
                data.forEach((obj) => {
                    allData = [...obj.Data, ...allData];
                });
            }
            setResponseData({ data: { Data: allData } });
            const modifiedData = onRequestEnd({ data: { Data: allData } });
            const resDataArr = modifiedData;
            if (auditJobObj.AuditType === "Item") {
                setResponseLocationGridData([...getItemLocationPoolFromResponse(allData[0], locationType)]);
            } else {
                setResponseLocationGridData([...resDataArr]);
            }
            setLocationGridData(resDataArr);
            setOverlayScreenShow(false);
            setShowDataNote(false);
        }
        kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), false);
    };
    useEffect(() => {
        if (isInitialLocationTypeRender.current) {
            isInitialLocationTypeRender.current = false;
            return;
        }
        if (auditJobObj.AuditType !== "Item") {
            return;
        }
        getLocationGridData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationType]);

    const sequence = (n) => {
        let seq = [];
        for (let i = 0; i < n; i++) {
            seq.push(i);
        }
        return seq;
    };
    const onChangeLocationType = (locType) => {
        if (locType === locationType) {
            return;
        }
        setLocationType(locType);
    };
    const onFilterChangeDebounce = () => {
        if ((filterObj.customerId === 0 || auditJobObj.ItemId === "") && auditJobObj.AuditType === "Item") {
            return;
        }
        kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), true);
        auditInventoryServices
            .locationGridSearchInfoSend({
                IndexOptionsLocation: 0,
                LocationType: filterObj.LocationType,
                Location: filterObj.LocationName,
                LastCountedDate: filterObj.LastCounted,
                ShowLastCountedDate: true,
                ShowLocationType: true,
                ShowLocation: true,
                FacilityId: props.facId,
            })
            .then((response) => {
                setRecordsCount(response.data);
                if (response.data < 0) {
                    setShowDataNote(false);
                } else if (response.data > gridPageSize) {
                    setShowDataNote(true);
                } else {
                    setShowDataNote(false);
                    getLocationGridData();
                }
                kendo.ui.progress($("#" + props.wmsSelector + "LocationGrid"), false);
            });
    };
    let onFilterChangeDebounceCall = GlobalService.useFCDebounce(onFilterChangeDebounce, 1000);
    const onSaveAuditJob = () => {
        setIsSaveAuditJobLoading(true);
        let locationsId = [];
        for (let i = 0; i < jobLocationsGridData.length; i++) {
            // eslint-disable-next-line security/detect-object-injection
            const location = jobLocationsGridData[i];
            locationsId.push({ Id: location.Id });
        }
        let tmpAuditJob = auditJobObj;
        if (tmpAuditJob.AssignedTo && !tmpAuditJob.AssignedTo.Id) {
            delete tmpAuditJob.AssignedTo;
        }
        tmpAuditJob.Locations = locationsId;
        tmpAuditJob.ItemId = auditJobObj.ItemId;
        auditInventoryServices
            .auditJob(auditJobObj, props.facUri, props.auditType)
            .then((response) => {
                GlobalService.notification(
                    "success",
                    window.translate(
                        props.auditType === "Create"
                            ? "Label_Job_Created_Successfully"
                            : "Label_Job_Updated_Successfully"
                    )
                );
                props.getAuditOptions(props.facUri);
            })
            .finally(() => {
                setIsSaveAuditJobLoading(false);
                props.onCloseManageAuditInventoryModal();
            });
    };

    return (
        <WmsModel
            id="ManageAuditInventoryModal"
            title={
                props.auditType === "Create" ? window.translate("Create_Audit_Job") : window.translate("Edit_Audit_Job")
            }
            width={1200}
            height={800}
            onCloseFunc={props.onCloseManageAuditInventoryModal}
            isOpen={props.isOpenManageAuditInventoryModal}
            customClass="wms-model-new-ui-wrapper"
            actions={["Minimize", "Maximize", "Close"]}
            overlayHide={false}
            windowId={props.windowId}
            appendTo={"#" + props.windowId}
        >
            <div className={"model-content-wrapper"}>
                <div className="general-fields-Wrapper">
                    <WmsInput
                        inputName="Name"
                        wmsSelector={props.wmsSelector + "SearchJobName"}
                        onChangeFunc={onChangeJobFields}
                        label={window.translate("Label_Cycle_count_Job_Name")}
                        required={true}
                        value={auditJobObj.Name}
                        extraWrapperClass={"job-name-wrapper"}
                    />
                    <WmsDropdown
                        id="AuditType"
                        name="AuditType"
                        label={window.translate("Label_Audit_Type")}
                        wmsSelector={props.wmsSelector + "AuditType"}
                        onChangeFunc={onChangeJobFields}
                        value={auditJobObj.AuditType}
                        options={auditTypeOptions}
                        valueField="value"
                        textField="name"
                        extraWrapperClass="audit-type-wrapper form_group"
                        disabled={auditJobObj.EditUri !== undefined && auditJobObj.EditUri.length > 0}
                    />
                    <WmsDropdownList
                        id={"AssignedTo"}
                        name="AssignedTo"
                        label={window.translate("Label_Assign_To")}
                        wmsSelector={props.wmsSelector + "AssignedTo"}
                        value={auditJobObj.AssignedTo ? auditJobObj.AssignedTo.Id : null}
                        onChangeFunc={onChangeJobFields}
                        valueField="Id"
                        textField="Name"
                        isVirtualOptions={false}
                        staticOptions={assignedToOptions}
                        extraWrapperClass="assigned-to-wrapper"
                        disabled={auditJobObj.BatchName !== null}
                    />
                    <WmsDropdown
                        id="Priority"
                        name="Priority"
                        label={window.translate("Label_Priority")}
                        wmsSelector={props.wmsSelector + "Priority"}
                        onChangeFunc={onChangeJobFields}
                        options={jobPriorityOption}
                        value={auditJobObj.Priority}
                        valueField="value"
                        textField="text"
                        extraWrapperClass="priority-wrapper form_group"
                        disabled={auditJobObj.BatchName !== null}
                    />
                    <WmsCheckBox
                        id={"UseTrackBys"}
                        name={"UseTrackBys"}
                        wmsSelector={props.wmsSelector + "SearchTrackBys"}
                        onChangeFunc={onChangeJobFields}
                        checked={auditJobObj.UseTrackBys}
                        label={window.translate("Label_Collect_MU_And_TrackBy")}
                        showToolTip={true}
                        tooltipText={
                            "If you choose not to collect track-by data as part of the audit, you cannot reconcile variances if any audited inventory has track-by data."
                        }
                    />
                </div>
                <div className="grid-fields-Wrapper">
                    {auditJobObj.AuditType === "Item" ? (
                        <div className="item-filter-wrapper">
                            <WmsDropdown
                                id="customerId"
                                name="customerId"
                                label={window.translate("Label_Customer_Text")}
                                wmsSelector={props.wmsSelector + "customerId"}
                                onChangeFunc={onFilterChange}
                                value={filterObj.customerId}
                                options={CustomerOptions}
                                textField={"name"}
                                valueField={"id"}
                                required={auditJobObj.AuditType === "Item"}
                                extraWrapperClass="customer-options-wrapper form_group"
                            />
                            <WmsToolTip
                                tooltipText={
                                    "Select the duration of item history used to identify suggested locations for this audit job."
                                }
                            >
                                <WmsDropdown
                                    id="pastndays"
                                    name="pastndays"
                                    label={window.translate("Label_Item_History_Size")}
                                    wmsSelector={props.wmsSelector + "pastndays"}
                                    onChangeFunc={onFilterChange}
                                    options={itemSize}
                                    valueField="value"
                                    textField="text"
                                    extraWrapperClass="select-an-item-wrapper form_group"
                                    value={filterObj.pastndays}
                                />
                            </WmsToolTip>
                            {filterObj.customerId !== 0 && (
                                <WmsDropdownList
                                    key={"AuditInventoryDropDownList" + auditJobObj.ItemId}
                                    id="AuditInventoryDropDownList"
                                    name="AuditInventoryDropDownList"
                                    label={window.translate("Label_Item")}
                                    optionsLabel={window.translate("Label_Select_Sku")}
                                    wmsSelector={props.wmsSelector + "audit-inventory-SkuDropDown"}
                                    onSelect={onItemFilterChange}
                                    value={auditJobObj.ItemId}
                                    disabled={!filterObj.customerId}
                                    onChangeFunc={() => {}}
                                    textField="Sku"
                                    valueField="Id"
                                    showDetailsTooltip={false}
                                    windowId={props.windowId}
                                    parentclassName="form-group"
                                    extraWrapperClass="select-an-item-wrapper form_group"
                                    required={auditJobObj.AuditType === "Item"}
                                    virtualObj={{
                                        itemHeight: 45,
                                        valueMapper: (options) => {
                                            var valueMapperOptions = options;
                                            $.ajax({
                                                url: "/WebUI/Inventory/EditAudits/SkuDropdownIndexRead",
                                                type: "POST",
                                                dataType: "json",
                                                data: {
                                                    itemId: valueMapperOptions.value || 0,
                                                    customerId: filterObj.customerId || 0,
                                                },
                                                success: function (data) {
                                                    options.success(data);
                                                },
                                            });
                                        },
                                    }}
                                    dataSourceObj={{
                                        type: "aspnetmvc-ajax",
                                        pageSize: 30,
                                        serverPaging: true,
                                        serverFiltering: true,
                                        transport: {
                                            read: {
                                                url: "/WebUI/Inventory/EditAudits/SkuDropDownRead",
                                                type: "POST",
                                                data: {
                                                    customerId: filterObj.customerId,
                                                },
                                            },
                                        },
                                        schema: {
                                            data: "Data",
                                            total: "Total",
                                        },
                                    }}
                                />
                            )}
                        </div>
                    ) : (
                        <div className="wrapper-filter">
                            <div className="label-wrapper label-wrapper-space">
                                <label>{window.translate("Label_Location_Filters")}</label>
                            </div>
                            <div className="locations-filter-wrapper">
                                <div className="wms-input-group-wrapper">
                                    <WmsInput
                                        inputName="LocationName"
                                        wmsSelector={props.wmsSelector + "SearchLocName"}
                                        value={filterObj.LocationName}
                                        onChangeFunc={onFilterChange}
                                        label={window.translate("Label_Location_Name")}
                                        parentClassName="input_box"
                                    />
                                </div>
                                <WmsDateTimePicker
                                    id={"LastCounted"}
                                    name="LastCounted"
                                    label={window.translate("Label_Cycle_count_Last_Counted")}
                                    onChangeFunc={onFilterChange}
                                    value={filterObj.LastCounted}
                                    required={false}
                                    wmsSelector={props.wmsSelector + "lastCounted"}
                                    format={lastCountedDateFormat}
                                    isDateParseInCustomFormat={true}
                                    onlyDate={true}
                                />
                                <WmsDropdown
                                    id="LocationType"
                                    name="LocationType"
                                    label={window.translate("Label_Location_Type")}
                                    wmsSelector={props.wmsSelector + "LocationType"}
                                    onChangeFunc={onFilterChange}
                                    value={filterObj.LocationType}
                                    options={locationTypes}
                                    valueField="Value"
                                    textField="Name"
                                    extraWrapperClass="form_group"
                                />
                            </div>
                        </div>
                    )}
                    <WmsCheckBox
                        id="HideInactive"
                        name="HideInactive"
                        label={window.translate("Label_Hide_Inactive")}
                        wmsSelector={props.wmsSelector + "HideInactive"}
                        checked={filterObj.hideInactive}
                        onChangeFunc={() => setFilterObj((p: any) => ({ ...p, hideInactive: !p.hideInactive }))}
                        parentClassName={auditJobObj.AuditType === "Location" ? "wms-checkbox-margin-top" : ""}
                    />
                </div>
                {auditJobObj.AuditType === "Item" && (
                    <div className="location-icon-wrapper">
                        <div className="location-type-Wrapper">
                            <div className="label-wrapper label-wrapper-space">
                                <label>{window.translate("Label_Location_Filters")}</label>
                            </div>
                            <div className="radio-wrapper">
                                <WmsRadio
                                    id="isOtherLocation"
                                    name="adjustmentType"
                                    label={window.translate("Label_Other")}
                                    wmsSelector={props.wmsSelector + "isOtherLocation-radio"}
                                    onChangeFunc={(e) => onChangeLocationType("other")}
                                    checked={locationType === "other"}
                                />
                                <WmsRadio
                                    id="isSuggestedLocation"
                                    name="adjustmentType"
                                    label={window.translate("Label_Suggested")}
                                    wmsSelector={props.wmsSelector + "isSuggestedLocation-radio"}
                                    onChangeFunc={(e) => onChangeLocationType("suggested")}
                                    checked={locationType === "suggested"}
                                />
                            </div>
                        </div>
                        <div className="locations-filter-wrapper d-flex filter-group">
                            <div className="wms-input-group-wrapper">
                                <WmsInput
                                    inputName="LocationName"
                                    wmsSelector={props.wmsSelector + "SearchLocName"}
                                    value={filterObj.LocationName}
                                    onChangeFunc={onFilterChange}
                                    label={window.translate("Label_Location_Name")}
                                />
                            </div>
                            <WmsDropdown
                                id="LocationType"
                                name="LocationType"
                                label={window.translate("Label_Location_Type")}
                                wmsSelector={props.wmsSelector + "LocationType"}
                                onChangeFunc={onFilterChange}
                                value={filterObj.LocationType}
                                options={locationTypes}
                                valueField="Value"
                                textField="Name"
                                extraWrapperClass="form_group"
                            />
                        </div>
                    </div>
                )}
                <div>
                    {/* eslint-disable */}
                    {auditJobObj.AuditType === "Location" || (filterObj.customerId && auditJobObj.ItemId) ? (
                        <div className="grid-wrapper">
                            <div className="job-location-grid-wrapper">
                                {showDataNote ? (
                                    <label style={{ color: "red", fontSize: "14px", marginBottom: "8px" }}>
                                        {window.translate("Location_Filter_Note")}
                                        <a href="#" onClick={loadAllData} className="click-link">
                                            {window.translate("Label_Grid_Filter_Message_Click_Here")}
                                        </a>
                                        {window.translate("Filter_Entire_List")}
                                    </label>
                                ) : (
                                    <div className="note-space"></div>
                                )}
                                <WMSGridCheckBoxSelection
                                    key={props.wmsSelector + "LocationGrid" + locationGridKeyNumber}
                                    id={props.wmsSelector + "LocationGrid"}
                                    staticGridData={locationGridData}
                                    schema={schema}
                                    columns={
                                        auditJobObj.AuditType === "Item" ? defaultItemsColumns : defaultLocationsColumns
                                    }
                                    onSelectRow={selectRow}
                                    changeRemoteGridColumn={false}
                                />
                            </div>
                            <div className="navigation-btn-wrapper">
                                <WmsButton
                                    label={""}
                                    wmsSelector={props.wmsSelector + "rightNavigate"}
                                    onClickFunc={moveLocationToJob}
                                    // disabled={locationNoOfSelection === 0}
                                    icon="fa-chevron-right"
                                />
                                <WmsButton
                                    label={""}
                                    wmsSelector={props.wmsSelector + "leftNavigate"}
                                    onClickFunc={moveJobToLocation}
                                    icon="fa-chevron-left"
                                />
                            </div>
                            <div className="audit-job-location-grid-wrapper">
                                <div className="location-icon-wrapper">
                                    <div className="icon-header-wrapper">
                                        <div className="required-header-wrapper">
                                            <span className="required-wrapper header-label">
                                                <label>R</label>
                                            </span>{" "}
                                            = Required
                                        </div>
                                        <div className="suggested-header-wrapper">
                                            <span className="required-wrapper header-label">
                                                <label>S</label>
                                            </span>{" "}
                                            = Suggested
                                        </div>
                                    </div>
                                </div>
                                <WMSGridCheckBoxSelection
                                    id={props.wmsSelector + "AuditJobLocation"}
                                    staticGridData={jobLocationsGridData}
                                    schema={jobLocationsSchema}
                                    columns={jobLocationColumns}
                                    changeColumnsDynamic={true}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={"grid-empty-block grid-wrapper"}>
                            <div className="job-location-grid-wrapper">
                                <WmsFormGrid
                                    id={"LocationGridEmpty"}
                                    wmsSelector={"LocationGridEmpty"}
                                    schema={schema}
                                    columns={defaultItemsColumns}
                                    staticGridData={[]}
                                    isColumnMenuenable={true}
                                    isColumnsFilterable={true}
                                    isColumnsResizable={true}
                                    isColumnsReorderable={true}
                                    parentClassName={"LocationGridEmpty"}
                                />
                            </div>
                            <div className="navigation-btn-wrapper">
                                <WmsButton
                                    label={""}
                                    wmsSelector={props.wmsSelector + "rightNavigateEmpty"}
                                    icon="fa-chevron-right"
                                    onClickFunc={() => {}}
                                />
                                <WmsButton
                                    label={""}
                                    wmsSelector={props.wmsSelector + "leftNavigateEmpty"}
                                    icon="fa-chevron-left"
                                    onClickFunc={() => {}}
                                />
                            </div>
                            <div className="audit-job-location-grid-wrapper">
                                <WmsFormGrid
                                    id={"AuditJobLocationEmpty"}
                                    wmsSelector={"AuditJobLocationEmpty"}
                                    schema={jobLocationsSchema}
                                    columns={jobLocationColumns}
                                    staticGridData={[]}
                                    parentClassName={"AuditJobLocationEmpty"}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="footer-btn-holder">
                <WmsButton
                    label={window.translate("Label_Cancel")}
                    wmsSelector={props.wmsSelector + "DiscardExit"}
                    onClickFunc={props.onCloseManageAuditInventoryModal}
                    buttonType="orange"
                    icon={"fa-ban"}
                />
                <WmsButton
                    label={window.translate("Label_Save")}
                    wmsSelector={props.wmsSelector + "Save"}
                    onClickFunc={onSaveAuditJob}
                    disabled={
                        !auditJobObj.Name ||
                        jobLocationsGridData.length === 0 ||
                        (auditJobObj.AuditType === "Item" ? !filterObj.customerId || !auditJobObj.ItemId : false)
                    }
                    icon={"fa-floppy-o"}
                    loading={isSaveAuditJobLoading}
                    parentClassName={"apply-adjustment-button"}
                />
            </div>
            {overlayScreenShow && (
                <LoadingModel
                    sharedOpenLoadingmodel={overlayScreenShow}
                    onCancelLoadAllData={cancelLoadAllData}
                    sharedTotalRequest={totalRequest}
                />
            )}
        </WmsModel>
    );
};
ManageAuditInventoryModal.propTypes = {
    onCloseManageAuditInventoryModal: PropTypes.any.isRequired,
    isOpenManageAuditInventoryModal: PropTypes.bool.isRequired,
    wmsSelector: PropTypes.string.isRequired,
    windowId: PropTypes.string.isRequired,
    auditType: PropTypes.string,
};

export default React.memo(ManageAuditInventoryModal);
